import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { getError, getLoading, State } from '../_state/filtro.selector';
import { GeneralBaseDto } from '../_models/general-base-dto';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-filtro-estado',
  standalone: false,
  templateUrl: 'filtro-estado.component.html',
  styleUrls: ['../filtro.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class FiltroEstadoComponent {

  @ViewChild("estadoSelect") estadoSelect: MatSelect;

  @Input() label: string = 'Estado';
  @Input() estados: GeneralBaseDto[];
  @Input() selectedEstadoId: number = 0;
  @Input() verTodos: boolean = true;
  @Input() disabled: boolean = false;
  @Output() selected = new EventEmitter<number>();

  loading$ = this.store.select(getLoading);
  errorMessage$ = this.store.select(getError);

  constructor(private store: Store<State>) { }

  doSelected(event: any) {
    this.selected.emit(event?.value ?? 0);
    this.estadoSelect.close();
  }

}
